// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"37":"3fbd5c8b","194":"8d18c56f","501":"871c0792","734":"c4d272ff","842":"574866ea"}[chunkId] + ".css";
};